// Wait for Product Personalizer to load
function waitForPPLR(callback) {
  if (typeof window.PPLR !== 'undefined' || document.querySelector('.pplr_preview_wrapper')) {
    callback();
  } else {
    setTimeout(function() { waitForPPLR(callback); }, 1000);
  }
}

document.addEventListener('DOMContentLoaded', function() {
  waitForPPLR(function() {
    console.log('waiting for pplr...');
    // Product Personalizer is loaded, now initialize zoom
  // Target all product media images
  const productMediaContainers = document.querySelectorAll('.product-media-container');
  
  productMediaContainers.forEach(container => {
    const img = container.querySelector('img:not(.svg-wrapper img)');
    
    if (img && !img.classList.contains('zoom-enabled')) {
      // Mark as processed
      img.classList.add('zoom-enabled');
      console.log('zoom-added.');
      
      // Add styles for zoom effect
      container.style.overflow = 'hidden';
      container.style.cursor = 'zoom-in';
      img.style.transition = 'transform 0.3s ease';
      img.style.transformOrigin = 'center center';
      
      // Mouse move event for zoom following cursor
      container.addEventListener('mousemove', function(e) {
        const rect = container.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / rect.width) * 100;
        const y = ((e.clientY - rect.top) / rect.height) * 100;
        
        img.style.transformOrigin = `${x}% ${y}%`;
        img.style.transform = 'scale(3)';

        console.log('mouse moving');
      });
      
      // Mouse leave event to reset zoom
      container.addEventListener('mouseleave', function() {
        img.style.transform = 'scale(1)';
        img.style.transformOrigin = 'center center';
      });
    }
  });
  
  // Re-apply zoom when slider changes (for gallery navigation)
  const slider = document.querySelector('#Slider-Gallery-template--18576664166618__main');
  if (slider) {
    // Watch for slider changes using MutationObserver
    const observer = new MutationObserver(function() {
      const activeSlide = slider.querySelector('.is-active');
      if (activeSlide) {
        const container = activeSlide.querySelector('.product-media-container');
        const img = container?.querySelector('img:not(.svg-wrapper img)');
        
        if (img && !img.classList.contains('zoom-enabled')) {
          img.classList.add('zoom-enabled');
          container.style.overflow = 'hidden';
          container.style.cursor = 'zoom-in';
          img.style.transition = 'transform 0.3s ease';
          
          container.addEventListener('mousemove', function(e) {
            const rect = container.getBoundingClientRect();
            const x = ((e.clientX - rect.left) / rect.width) * 100;
            const y = ((e.clientY - rect.top) / rect.height) * 100;
            
            img.style.transformOrigin = `${x}% ${y}%`;
            img.style.transform = 'scale(1.5)';
          });
          
          container.addEventListener('mouseleave', function() {
            img.style.transform = 'scale(1)';
            img.style.transformOrigin = 'center center';
          });
        }
      }
    });
    
    observer.observe(slider, { 
      attributes: true, 
      childList: true, 
      subtree: true 
    });
  }
  }); // Close waitForPPLR callback
}); // Close DOMContentLoaded